export const ClickOutside = {
  mounted(el: any, binding: any) {
    el.clickOutsideEvent = (event: { target: any }) => {
      if (!(el == event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el: any) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
};
